@if (position) {
  <div class="drawer-body">
    <div class="flex align-item-center ">
      <div class="flex-grow-1 p-2">
        <div class="f-w-500">

          @if (!(position)?.sensors?.ignition) {
            <div class="text-accent-500 ">
              <i class="fa-solid fa-power-off"></i>
              Motor Apagado
            </div>
          } @else {
            <div  class="text-success-500 ">
              <i class="fa-solid fa-power-off"></i>
              Motor Encendido
            </div>
          }

          @if ((position)?.speed > 2) {
            <div class="text-primary-500 ">
              <i class="fa-solid fa-gauge-simple-high"></i>
              En movimiento a {{ ((position)?.speed)  | renderSpeed }}
            </div>
          } @else {
            <div  class=" text-warn-500 ">
              <i class="fa-solid fa-gauge-simple"></i>
              Estacionado
            </div>
          }
          <div >
            <i class="fa-solid fa-link"></i>
            Fecha de reporte: {{ position.deviceTime | toDateTimeFormat }}
          </div>
        </div>
      </div>
    </div>

    <br />
    <br/>

    <app-card [showHeader]="false" padding="10" cardClass="social-widget-card m-b-15">
      <div>
        Dirección
      </div>
      <p class="mat-body text-muted text-wrap">{{ (position)?.address }}</p>
        <i class="fi fi-rr-direction-signal"></i>
    </app-card>


    <app-card [showHeader]="false" padding="15" cardClass="social-widget-card bg-accent-500 text-white">
      <div>Odometro</div>

      <h3 class="m-b-5 f-w-500">
        {{ ((position)?.properties.odometerDay || 0).toFixed(1) }}
      </h3>
      <i class="fa-solid fa-gauge-high"></i>
    </app-card>

    <app-card [cardTitle]="'Atributos nativos'" padding="10">
      @for (attr of attributes; track attr) {
        <app-card class="list-group-item my-task" [showHeader]="false" padding="5">
          <div class="flex align-item-center">
            <div class="flex-grow-1 m-l-10">
              <span class="f-w-600">{{attr.key}} </span><span class="task-time ">{{attr.type}}</span>
              <p class="m-b-5">
              </p>

              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                  <code >{{attr.value}}</code>
                </div>
              </div>
            </div>

          </div>
        </app-card>
      }
    </app-card>

    <app-card [cardTitle]="'Atributos calculados'" padding="10">
      @for (attr of properties; track attr) {
        <app-card class="list-group-item my-task" [showHeader]="false" padding="5">
          <div class="flex align-item-center">
            <div class="flex-grow-1 m-l-10">
              <span class="f-w-600">{{attr.key}} </span><span class="task-time ">{{attr.type}}</span>
              <p class="m-b-5">
              </p>

              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                  <code >{{attr.value}}</code>
                </div>
              </div>
            </div>

          </div>
        </app-card>
      }
    </app-card>

    <app-card [cardTitle]="'Sensores'" padding="10">
      @for (attr of sensors; track attr) {
        <app-card class="list-group-item my-task" [showHeader]="false" padding="5">
          <div class="flex align-item-center">
            <div class="flex-grow-1 m-l-10">
              <span class="f-w-600">{{attr.key}} </span><span class="task-time ">{{attr.type}}</span>
              <p class="m-b-5">
              </p>

              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                  <code >{{attr.value}}</code>
                </div>
              </div>
            </div>

          </div>
        </app-card>
      }
    </app-card>

  </div>
}
